import React, { useState } from "react";
import { Row, Col, Button, Input, Form } from "reactstrap";
import { BsAt } from "react-icons/bs";
import classes from "../../Login/LoginForm.module.css";
import axios from "../../../Utils/axios";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation(); // ✅ Hook i18n

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post("/password_reset", { email });
      if (res.data.status === "success") {
        toast.success(res.data.message || t("reset_email_sent"));
      } else if (res.data.status === "email_not_found") {
        toast.error(res.data.message || t("email_not_found"));
      }
    } catch (err) {
      toast.error(t("generic_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row className={classes.formContainer}>
      <ToastContainer position="top-right" autoClose={5000} />
      <Col xs={12} md={6} className="mx-auto">
        <h4 className={classes.headerTitle}>{t("forgot_password")}</h4>

        <Form onSubmit={handleSubmit}>
          <div className={`mb-3 ${classes.inputWithIcon}`}>
            <Input
              type="email"
              placeholder={t("enter_email")}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={classes.input}
              required
            />
            <span className={classes.icon}>
              <BsAt />
            </span>
          </div>

          <Button
            className={`btn ${classes.buttonStyle} w-100`}
            type="submit"
            disabled={loading}
          >
            {loading ? t("sending") : t("send")}
          </Button>
        </Form>

        <div className="text-center mt-4">
          <p style={{ color: "rgb(130,130,130)", fontSize: "14px" }}>
            {t("back_to")}{" "}
            <a href="/login" style={{ textDecoration: "none", color: "#007bff" }}>
              {t("login")}
            </a>
          </p>
        </div>
      </Col>
    </Row>
  );
}